
// // import React, { useState, useEffect } from "react";
// // import { useLocation, useNavigate } from "react-router-dom";
// // import { postData, getData, serverURL } from "../../../../Services/Fetchnodeservices";
// // import { Image as ImageIcon, Plus, Sparkles, X, ChevronLeft, ChevronRight } from 'lucide-react'; 
// // import AIScanModal from "./AIScanModal";
// // import EditItemModal from "./EditItemModal";

// // const getThemeStyles = (isDark) => {
// //   const themes = {
// //     dark: {
// //       background: "#0a0e1a", surface: "#141b2f", surfaceLighter: "#1e2747",
// //       border: "#2a3f5f", borderAccent: "#3d5a8c", textPrimary: "#f8fafc",
// //       textSecondary: "#cbd5e1", textMuted: "#94a3b8", primary: "#60a5fa",
// //       primaryLight: "#93c5fd", primaryDark: "#1e40af", success: "#34d399",
// //       successLight: "#6ee7b7", error: "#f87171", warning: "#fbbf24",
// //       gradientPrimary: "linear-gradient(135deg, #60a5fa 0%, #a78bfa 50%, #f472b6 100%)",
// //       gradientCard: "linear-gradient(135deg, #1e2747 0%, #141b2f 100%)",
// //       shadowMd: "0 8px 16px rgba(0,0,0,0.2)",
// //     },
// //     light: {
// //       background: "#f8fafc", surface: "#ffffff", surfaceLighter: "#f1f5f9",
// //       border: "#e2e8f0", borderAccent: "#cbd5e1", textPrimary: "#0f172a",
// //       textSecondary: "#334155", textMuted: "#64748b", primary: "#3b82f6",
// //       primaryLight: "#60a5fa", primaryDark: "#1e40af", success: "#10b981",
// //       successLight: "#34d399", error: "#ef4444", warning: "#f59e0b",
// //       gradientPrimary: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 50%, #ec4899 100%)",
// //       gradientCard: "linear-gradient(135deg, #ffffff 0%, #f8f4ff 100%)",
// //       shadowMd: "0 8px 16px rgba(0,0,0,0.1)",
// //     },
// //   };
// //   return themes[isDark ? 'dark' : 'light'];
// // };

// // const Admin = ({ isDark = true }) => {
// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const ts = getThemeStyles(isDark);

// //   const [menuItems, setMenuItems] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [search, setSearch] = useState("");
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const itemsPerPage = 10;
  
// //   const [showAIScanModal, setShowAIScanModal] = useState(false);
// //   const [showEditModal, setShowEditModal] = useState(false);
// //   const [selectedItem, setSelectedItem] = useState(null);
// //   const [vendorMenus, setVendorMenus] = useState([]);
// //   const [preSelectedImage, setPreSelectedImage] = useState(null);

// //   const designation_id = location.state?.designation_id || JSON.parse(sessionStorage.getItem('selectedRestaurant') || '{}').designation_id;
// //   const restaurantName = location.state?.restaurantName || JSON.parse(sessionStorage.getItem('selectedRestaurant') || '{}').restaurantName;

// //   const fetchMenu = async () => {
// //     if (!designation_id) return;
// //     setLoading(true);
// //     try {
// //       const response = await postData("restaurant/Menubydesignation_id", { designation_id });
// //       let itemsArray = [];
// //       if (Array.isArray(response) && response[0]?.items) {
// //         itemsArray = typeof response[0].items === 'string' ? JSON.parse(response[0].items) : response[0].items;
// //       }
// //       setMenuItems(itemsArray);
// //     } catch (err) { console.error(err); }
// //     finally { setLoading(false); }
// //   };

// //   const fetchVendorUploadedMenus = async () => {
// //     try {
// //       const resp = await getData(`menuScanner/requests-by-restaurant/${designation_id}`);
// //       if (resp.success) {
// //         const allFiles = [];
// //         resp.data.forEach(req => {
// //             const files = Array.isArray(req.files) ? req.files : JSON.parse(req.files || '[]');
// //             files.forEach(f => {
// //                 if (f.type === 'image') allFiles.push({ filename: f.name, date: req.created_at });
// //             });
// //         });
// //         setVendorMenus(allFiles);
// //       }
// //     } catch (e) { console.error(e); }
// //   };

// //   useEffect(() => { 
// //     fetchMenu(); 
// //     fetchVendorUploadedMenus();
// //   }, [designation_id]);

// //   const handleDelete = async (productId) => {
// //     if (!window.confirm("Bhai, pakka delete karna hai?")) return;
// //     try {
// //       const resp = await postData(`menu/delete-item/${designation_id}/${productId}`, {}, "DELETE");
// //       if (resp.success) fetchMenu();
// //     } catch (e) { console.error(e); }
// //   };

// //   const handleScanVendorImage = (filename) => {
// //     setPreSelectedImage(filename);
// //     setShowAIScanModal(true);
// //   };

// //   // ===== ROBUST PRICING HELPERS =====
// //   // For items without variants: try to use requested_price as menu, else derive from price
// //   const getMenuAndCustPrices = (item) => {
// //     const price = parseFloat(item.price) || 0;
// //     const reqPrice = parseFloat(item.requested_price) || 0;
// //     let menuPrice, custPrice;
// //     if (reqPrice > 0 && reqPrice < price) {
// //       menuPrice = reqPrice;
// //       custPrice = price;
// //     } else {
// //       // fallback: treat price as customer, derive menu = price/1.2
// //       menuPrice = price / 1.2;
// //       custPrice = price;
// //     }
// //     return { menuPrice, custPrice };
// //   };

// //   // For variants: prefer variant.price (AI detected menu) or actual_price, else derive from item_price_variant
// //   const getVariantPricing = (variant) => {
// //     // Try to get menu price from variant.price or actual_price
// //     let menuPrice = parseFloat(variant.price) || parseFloat(variant.actual_price) || 0;
// //     if (!menuPrice) {
// //       // fallback: derive from customer price
// //       const cust = parseFloat(variant.item_price_variant) || 0;
// //       menuPrice = cust / 1.2;
// //     }
// //     const custPrice = Math.round(menuPrice * 1.2);
// //     return { menuPrice, custPrice };
// //   };

// //   const filteredItems = menuItems.filter(item =>
// //     item.name?.toLowerCase().includes(search.toLowerCase()) ||
// //     item.category?.toLowerCase().includes(search.toLowerCase())
// //   );

// //   const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
// //   const currentItems = filteredItems.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

// //   const styles = {
// //     container: { minHeight: "100vh", background: ts.background, padding: "32px 40px", color: ts.textPrimary, fontFamily: 'Inter, sans-serif' },
// //     card: { background: ts.surface, border: `1px solid ${ts.border}`, borderRadius: "24px", padding: "32px", marginBottom: "32px", boxShadow: ts.shadowMd, backgroundImage: ts.gradientCard },
// //     vendorGrid: { display: 'flex', gap: '15px', overflowX: 'auto', paddingBottom: '10px', marginBottom: '32px' },
// //     vendorImgBox: { minWidth: '120px', height: '160px', borderRadius: '12px', border: `2px dashed ${ts.border}`, background: ts.surfaceLighter, overflow: 'hidden', cursor: 'pointer', position: 'relative' },
// //     table: { width: "100%", borderCollapse: "collapse" },
// //     th: { padding: "16px", textAlign: "left", fontSize: "12px", fontWeight: 700, color: ts.primary, background: ts.surfaceLighter, textTransform: "uppercase", borderBottom: `1px solid ${ts.border}` },
// //     td: { padding: "14px 16px", borderBottom: `1px solid ${ts.border}`, fontSize: "13px", color: ts.textSecondary },
// //     badge: { display: 'block', fontSize: '10px', background: ts.surfaceLighter, padding: '3px 8px', borderRadius: '5px', marginBottom: '4px', border: `1px solid ${ts.border}` },
// //     img: { width: "50px", height: "50px", borderRadius: "10px", objectFit: "cover", border: `1px solid ${ts.border}` },
// //     paginationBtn: (active) => ({ padding: "8px 16px", borderRadius: "10px", border: `1px solid ${active ? ts.primary : ts.border}`, background: active ? ts.primary : ts.surface, color: active ? "white" : ts.textSecondary, cursor: "pointer", margin: "0 4px", fontSize: '12px', fontWeight: 600 })
// //   };

// //   return (
// //     <div style={styles.container}>
// //       <style>{`
// //         tr:hover { background: ${ts.primary}08 !important; } 
// //         input:focus { border-color: ${ts.primary} !important; outline: none; }
// //         .vendor-box:hover .scan-overlay { opacity: 1 !important; }
// //         ::-webkit-scrollbar { height: 6px; }
// //         ::-webkit-scrollbar-thumb { background: ${ts.border}; borderRadius: 10px; }
// //       `}</style>
      
// //       <button style={{ background: ts.surfaceLighter, color: ts.primary, border: `1px solid ${ts.border}`, padding: '10px 20px', borderRadius: '12px', cursor: 'pointer', marginBottom: '24px', display:'flex', alignItems:'center', gap:'8px' }} onClick={() => navigate(-1)}>
// //         <ChevronLeft size={18}/> Back
// //       </button>

// //       <div style={styles.card}>
// //         <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'20px'}}>
// //             <div>
// //                 <h1 style={{ margin: 0, fontSize: '30px', fontWeight: 800, background: ts.gradientPrimary, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{restaurantName}</h1>
// //                 <p style={{color: ts.textMuted, margin:'5px 0 0 0'}}>Manage dishes and scan new menus</p>
// //             </div>
// //             <button onClick={() => {setPreSelectedImage(null); setShowAIScanModal(true)}} style={{ background: ts.primary, color: 'black', border: 'none', padding: '12px 24px', borderRadius: '12px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
// //                 <Sparkles size={16}/> AI Scan Menu
// //             </button>
// //         </div>
// //       </div>

// //       {/* VENDOR MENU IMAGES SECTION */}
// //       <div style={{marginBottom: '15px', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '8px'}}>
// //          <ImageIcon size={18} color={ts.primary}/> Menu Pages & PDFs (Sent by Vendor)
// //       </div>
// //       <div style={styles.vendorGrid}>
// //         {vendorMenus.length > 0 ? vendorMenus.map((menu, i) => (
// //           <div key={i} className="vendor-box" style={styles.vendorImgBox} onClick={() => handleScanVendorImage(menu.filename)}>
// //               <img src={`${serverURL}/uploads/${menu.filename}`} style={{width:'100%', height:'100%', objectFit:'cover'}} alt="menu-page" onError={(e) => { e.target.src = "https://via.placeholder.com/120x160?text=Menu+Page"; }}/>
// //               <div className="scan-overlay" style={{position:'absolute', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', opacity:0, transition:'0.3s'}}>
// //                   <Sparkles size={20} color="white"/>
// //               </div>
// //               <div style={{position:'absolute', bottom:0, width:'100%', padding:'4px', background:'rgba(0,0,0,0.7)', fontSize:'10px', color:'white', textAlign:'center'}}>
// //                   Page {i+1}
// //               </div>
// //           </div>
// //         )) : [1,2,3,4,5].map(n => (
// //           <div key={n} style={{...styles.vendorImgBox, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', color: ts.textMuted, opacity: 0.5}}>
// //               <Plus size={24} />
// //               <span style={{fontSize:'10px', marginTop:'5px'}}>Page {n}</span>
// //           </div>
// //         ))}
// //       </div>

// //       <input style={{ width: '100%', padding: '14px', borderRadius: '14px', background: ts.surface, border: `1px solid ${ts.border}`, color: ts.textPrimary, marginBottom: '24px' }} placeholder="Search dish by name..." value={search} onChange={(e) => {setSearch(e.target.value); setCurrentPage(1);}} />

// //       <div style={{ ...styles.card, padding: 0, overflow: 'hidden' }}>
// //         <table style={styles.table}>
// //           <thead>
// //             <tr>
// //               <th style={styles.th}>Dish</th>
// //               <th style={styles.th}>Item Details</th>
// //               <th style={styles.th}>Menu Price</th>
// //               <th style={styles.th}>Cust. Price</th>
// //               <th style={styles.th}>Profit (20%)</th>
// //               <th style={styles.th}>Type</th>
// //               <th style={styles.th}>Actions</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {currentItems.map((item, idx) => {
// //               let variants = [];
// //               try {
// //                 variants = Array.isArray(item.variant) ? item.variant : JSON.parse(item.variant || '[]');
// //               } catch(e) { variants = []; }

// //               if (variants.length === 0) {
// //                 const { menuPrice, custPrice } = getMenuAndCustPrices(item);
// //                 return (
// //                   <tr key={idx}>
// //                     <td style={styles.td}>
// //                       <img src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`} style={styles.img} onError={e => e.target.src="https://via.placeholder.com/50"} />
// //                     </td>
// //                     <td style={styles.td}>
// //                       <div style={{ fontWeight: 700, color: ts.textPrimary, fontSize: '15px' }}>{item.name}</div>
// //                       <div style={{ fontSize: '11px', color: ts.textMuted }}>{item.description?.substring(0,40)}...</div>
// //                     </td>
// //                     <td style={styles.td}>
// //                       <span style={{ fontWeight: 600, color: ts.textPrimary }}>₹{menuPrice.toFixed(0)}</span>
// //                     </td>
// //                     <td style={styles.td}>
// //                       <span style={{ color: ts.success, fontWeight: 700 }}>₹{custPrice.toFixed(0)}</span>
// //                     </td>
// //                     <td style={styles.td}>
// //                       <span style={{ color: ts.primary }}>+₹{(custPrice - menuPrice).toFixed(0)}</span>
// //                     </td>
// //                     <td style={styles.td}>
// //                       <span style={{ padding: '4px 10px', borderRadius: '8px', background: item.is_veg === 'yes' ? "#065f46" : "#991b1b", color: "white", fontSize: '10px', fontWeight: 700 }}>{item.is_veg === 'yes' ? "VEG" : "NON-VEG"}</span>
// //                     </td>
// //                     <td style={styles.td}>
// //                       <div style={{ display: 'flex', gap: '10px' }}>
// //                         <button onClick={() => {setSelectedItem(item); setShowEditModal(true)}} style={{ background: 'none', border: 'none', color: ts.primary, cursor: 'pointer' }}><Sparkles size={14} /></button>
// //                         <button onClick={() => handleDelete(item.product_id)} style={{ background: 'none', border: 'none', color: ts.error, cursor: 'pointer' }}><X size={14}/></button>
// //                       </div>
// //                     </td>
// //                   </tr>
// //                 );
// //               }

// //               // With variants – each variant row, first row spans image & name
// //               return variants.map((v, vIdx) => {
// //                 const { menuPrice, custPrice } = getVariantPricing(v);
// //                 return (
// //                   <tr key={`${idx}-${vIdx}`}>
// //                     {vIdx === 0 && (
// //                       <>
// //                         <td style={styles.td} rowSpan={variants.length}>
// //                           <img src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`} style={styles.img} onError={e => e.target.src="https://via.placeholder.com/50"} />
// //                         </td>
// //                         <td style={styles.td} rowSpan={variants.length}>
// //                           <div style={{ fontWeight: 700, color: ts.textPrimary, fontSize: '15px' }}>{item.name}</div>
// //                           <div style={{ fontSize: '11px', color: ts.textMuted }}>{item.description?.substring(0,40)}...</div>
// //                         </td>
// //                       </>
// //                     )}
// //                     <td style={styles.td}>
// //                       <span style={{ fontWeight: 600, color: ts.textPrimary }}>{v.unit_value || 'Price'}: ₹{menuPrice.toFixed(0)}</span>
// //                     </td>
// //                     <td style={styles.td}>
// //                       <span style={{ color: ts.success, fontWeight: 700 }}>{v.unit_value || 'Price'}: ₹{custPrice.toFixed(0)}</span>
// //                     </td>
// //                     <td style={styles.td}>
// //                       <span style={{ color: ts.primary }}>+₹{(custPrice - menuPrice).toFixed(0)}</span>
// //                     </td>
// //                     {vIdx === 0 && (
// //                       <>
// //                         <td style={styles.td} rowSpan={variants.length}>
// //                           <span style={{ padding: '4px 10px', borderRadius: '8px', background: item.is_veg === 'yes' ? "#065f46" : "#991b1b", color: "white", fontSize: '10px', fontWeight: 700 }}>{item.is_veg === 'yes' ? "VEG" : "NON-VEG"}</span>
// //                         </td>
// //                         <td style={styles.td} rowSpan={variants.length}>
// //                           <div style={{ display: 'flex', gap: '10px' }}>
// //                             <button onClick={() => {setSelectedItem(item); setShowEditModal(true)}} style={{ background: 'none', border: 'none', color: ts.primary, cursor: 'pointer' }}><Sparkles size={14} /></button>
// //                             <button onClick={() => handleDelete(item.product_id)} style={{ background: 'none', border: 'none', color: ts.error, cursor: 'pointer' }}><X size={14}/></button>
// //                           </div>
// //                         </td>
// //                       </>
// //                     )}
// //                   </tr>
// //                 );
// //               });
// //             })}
// //           </tbody>
// //         </table>

// //         {/* Pagination */}
// //         <div style={{ padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: `1px solid ${ts.border}`, background: ts.surfaceLighter }}>
// //             <div style={{fontSize:'12px', color: ts.textMuted}}>
// //                 Showing {currentItems.length} of {filteredItems.length} items
// //             </div>
// //             <div style={{ display: 'flex', alignItems: 'center' }}>
// //                 <button 
// //                   disabled={currentPage === 1} 
// //                   onClick={() => setCurrentPage(currentPage - 1)}
// //                   style={{...styles.paginationBtn(false), opacity: currentPage === 1 ? 0.5 : 1}}
// //                 >
// //                     <ChevronLeft size={16}/>
// //                 </button>
                
// //                 {[...Array(totalPages)].map((_, i) => (
// //                     <button 
// //                       key={i} 
// //                       onClick={() => setCurrentPage(i + 1)}
// //                       style={styles.paginationBtn(currentPage === i + 1)}
// //                     >
// //                         {i + 1}
// //                     </button>
// //                 ))}

// //                 <button 
// //                   disabled={currentPage === totalPages} 
// //                   onClick={() => setCurrentPage(currentPage + 1)}
// //                   style={{...styles.paginationBtn(false), opacity: currentPage === totalPages ? 0.5 : 1}}
// //                 >
// //                     <ChevronRight size={16}/>
// //                 </button>
// //             </div>
// //         </div>
// //       </div>
      
// //       <AIScanModal 
// //         isOpen={showAIScanModal} 
// //         onClose={() => {setShowAIScanModal(false); setPreSelectedImage(null);}} 
// //         designationId={designation_id} 
// //         restaurantName={restaurantName} 
// //         onItemsAdded={fetchMenu}
// //         preSelectedServerImage={preSelectedImage} 
// //       />
// //       {showEditModal && <EditItemModal isOpen={showEditModal} onClose={()=>setShowEditModal(false)} item={selectedItem} designationId={designation_id} onUpdate={fetchMenu} ts={ts} />}
// //     </div>
// //   );
// // };
// // export default Admin;

// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { postData, getData, serverURL } from "../../../../Services/Fetchnodeservices";
// import { Image as ImageIcon, Plus, Sparkles, X, ChevronLeft, ChevronRight, Percent } from 'lucide-react'; 
// import AIScanModal from "./AIScanModal";
// import EditItemModal from "./EditItemModal";

// const getThemeStyles = (isDark) => {
//   const themes = {
//     dark: {
//       background: "#0a0e1a", surface: "#141b2f", surfaceLighter: "#1e2747",
//       border: "#2a3f5f", borderAccent: "#3d5a8c", textPrimary: "#f8fafc",
//       textSecondary: "#cbd5e1", textMuted: "#94a3b8", primary: "#60a5fa",
//       primaryLight: "#93c5fd", primaryDark: "#1e40af", success: "#34d399",
//       successLight: "#6ee7b7", error: "#f87171", warning: "#fbbf24",
//       gradientPrimary: "linear-gradient(135deg, #60a5fa 0%, #a78bfa 50%, #f472b6 100%)",
//       gradientCard: "linear-gradient(135deg, #1e2747 0%, #141b2f 100%)",
//       shadowMd: "0 8px 16px rgba(0,0,0,0.2)",
//     },
//     light: {
//       background: "#f8fafc", surface: "#ffffff", surfaceLighter: "#f1f5f9",
//       border: "#e2e8f0", borderAccent: "#cbd5e1", textPrimary: "#0f172a",
//       textSecondary: "#334155", textMuted: "#64748b", primary: "#3b82f6",
//       primaryLight: "#60a5fa", primaryDark: "#1e40af", success: "#10b981",
//       successLight: "#34d399", error: "#ef4444", warning: "#f59e0b",
//       gradientPrimary: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 50%, #ec4899 100%)",
//       gradientCard: "linear-gradient(135deg, #ffffff 0%, #f8f4ff 100%)",
//       shadowMd: "0 8px 16px rgba(0,0,0,0.1)",
//     },
//   };
//   return themes[isDark ? 'dark' : 'light'];
// };

// const Admin = ({ isDark = true }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const ts = getThemeStyles(isDark);

//   const [menuItems, setMenuItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
  
//   const [showAIScanModal, setShowAIScanModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [vendorMenus, setVendorMenus] = useState([]);
//   const [preSelectedImage, setPreSelectedImage] = useState(null);

//  const [commission, setCommission] = useState(20); // default
//   const [showCommissionModal, setShowCommissionModal] = useState(false);
//   const [tempCommission, setTempCommission] = useState(20);

//   const designation_id = location.state?.designation_id || JSON.parse(sessionStorage.getItem('selectedRestaurant') || '{}').designation_id;
//   const restaurantName = location.state?.restaurantName || JSON.parse(sessionStorage.getItem('selectedRestaurant') || '{}').restaurantName;

// const fetchRestaurantDetails = async () => {
//     if (!designation_id) return;
//     try {
//       const response = await getData(`/restaurants/Restrunts/${designation_id}`);
//       if (response.status && response.data) {
//         const com = parseFloat(response.data.comission) || 20;
//         setCommission(com);
//         setTempCommission(com);
//       }
//     } catch (e) {
//       console.error("Failed to fetch restaurant details:", e);
//     }
//   };

//    const fetchMenu = async () => {
//     if (!designation_id) return;
//     setLoading(true);
//     try {
//       const response = await postData("restaurant/Menubydesignation_id", { designation_id });
//       let itemsArray = [];
//       if (Array.isArray(response) && response[0]?.items) {
//         itemsArray = typeof response[0].items === 'string' ? JSON.parse(response[0].items) : response[0].items;
//       }
//       setMenuItems(itemsArray);
//     } catch (err) { console.error(err); }
//     finally { setLoading(false); }
//   };

//     const fetchVendorUploadedMenus = async () => {
//     try {
//       const resp = await getData(`menuScanner/requests-by-restaurant/${designation_id}`);
//       if (resp.success) {
//         const allFiles = [];
//         resp.data.forEach(req => {
//             const files = Array.isArray(req.files) ? req.files : JSON.parse(req.files || '[]');
//             files.forEach(f => {
//                 if (f.type === 'image') allFiles.push({ filename: f.name, date: req.created_at });
//             });
//         });
//         setVendorMenus(allFiles);
//       }
//     } catch (e) { console.error(e); }
//   };

//   useEffect(() => { 
//     fetchRestaurantDetails();
//     fetchMenu(); 
//     fetchVendorUploadedMenus();
//   }, [designation_id]);


//    const handleDelete = async (productId) => {
//     if (!window.confirm("Bhai, pakka delete karna hai?")) return;
//     try {
//       const resp = await postData(`menu/delete-item/${designation_id}/${productId}`, {}, "DELETE");
//       if (resp.success) fetchMenu();
//     } catch (e) { console.error(e); }
//   };

//    const handleScanVendorImage = (filename) => {
//     setPreSelectedImage(filename);
//     setShowAIScanModal(true);
//   };

// const handleUpdateCommission = async () => {
//     try {
//       const resp = await postData(`/restaurants/updaterestaurant/${designation_id}`, {
//         comission: tempCommission
//       }, "PUT");
//       if (resp.success) {
//         setCommission(tempCommission);
//         setShowCommissionModal(false);
//         // Optionally refresh menu to reflect new prices
//         fetchMenu();
//       } else {
//         alert("Failed to update commission");
//       }
//     } catch (e) {
//       console.error(e);
//       alert("Error updating commission");
//     }
//   };


//   // ===== PRICING HELPERS – नया लॉजिक =====
//   // For items without variants: requested_price = menu price, price = customer price
//   // vendor = customer * 0.8, commission = customer * 0.2
//   const getMenuCustomerVendor = (item) => {
//     const menu = parseFloat(item.requested_price) || 0;
//     let customer = parseFloat(item.price) || 0;
//     const com = commission / 100;
//     // If customer missing, derive from menu
//     if (!customer && menu) {
//       customer = Math.round(menu * (1 + com));
//     }
//     // If menu missing, derive from customer
//     if (!menu && customer) {
//       const vendor = Math.round(customer * (1 - com));
//       const profit = customer - vendor;
//       return { menu: Math.round(customer / (1 + com)), customer, vendor, profit };
//     }
//     const vendor = Math.round(customer * (1 - com));
//     const profit = customer - vendor;
//     return { menu, customer, vendor, profit };
//   };

//   // For variants: actual_price = menu price, item_price_variant = customer price
//  const getVariantPricing = (variant) => {
//     const menu = parseFloat(variant.actual_price) || 0;
//     let customer = parseFloat(variant.item_price_variant) || 0;
//     const com = commission / 100;
//     if (!customer && menu) {
//       customer = Math.round(menu * (1 + com));
//     }
//     if (!menu && customer) {
//       const vendor = Math.round(customer * (1 - com));
//       const profit = customer - vendor;
//       return { menu: Math.round(customer / (1 + com)), customer, vendor, profit };
//     }
//     const vendor = Math.round(customer * (1 - com));
//     const profit = customer - vendor;
//     return { menu, customer, vendor, profit };
//   };

//  const filteredItems = menuItems.filter(item =>
//     item.name?.toLowerCase().includes(search.toLowerCase()) ||
//     item.category?.toLowerCase().includes(search.toLowerCase())
//   );

//   const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
//   const currentItems = filteredItems.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
//   const styles = {
//     container: { minHeight: "100vh", background: ts.background, padding: "32px 40px", color: ts.textPrimary, fontFamily: 'Inter, sans-serif' },
//     card: { background: ts.surface, border: `1px solid ${ts.border}`, borderRadius: "24px", padding: "32px", marginBottom: "32px", boxShadow: ts.shadowMd, backgroundImage: ts.gradientCard },
//     vendorGrid: { display: 'flex', gap: '15px', overflowX: 'auto', paddingBottom: '10px', marginBottom: '32px' },
//     vendorImgBox: { minWidth: '120px', height: '160px', borderRadius: '12px', border: `2px dashed ${ts.border}`, background: ts.surfaceLighter, overflow: 'hidden', cursor: 'pointer', position: 'relative' },
//     table: { width: "100%", borderCollapse: "collapse" },
//     th: { padding: "16px", textAlign: "left", fontSize: "12px", fontWeight: 700, color: ts.primary, background: ts.surfaceLighter, textTransform: "uppercase", borderBottom: `1px solid ${ts.border}` },
//     td: { padding: "14px 16px", borderBottom: `1px solid ${ts.border}`, fontSize: "13px", color: ts.textSecondary },
//     badge: { display: 'block', fontSize: '10px', background: ts.surfaceLighter, padding: '3px 8px', borderRadius: '5px', marginBottom: '4px', border: `1px solid ${ts.border}` },
//     img: { width: "50px", height: "50px", borderRadius: "10px", objectFit: "cover", border: `1px solid ${ts.border}` },
//     paginationBtn: (active) => ({ padding: "8px 16px", borderRadius: "10px", border: `1px solid ${active ? ts.primary : ts.border}`, background: active ? ts.primary : ts.surface, color: active ? "white" : ts.textSecondary, cursor: "pointer", margin: "0 4px", fontSize: '12px', fontWeight: 600 })
//   };


//   return (
//     <div style={styles.container}>
//       <style>{`
//         tr:hover { background: ${ts.primary}08 !important; } 
//         input:focus { border-color: ${ts.primary} !important; outline: none; }
//         .vendor-box:hover .scan-overlay { opacity: 1 !important; }
//         ::-webkit-scrollbar { height: 6px; }
//         ::-webkit-scrollbar-thumb { background: ${ts.border}; borderRadius: 10px; }
//       `}</style>
      
//       <button style={{ background: ts.surfaceLighter, color: ts.primary, border: `1px solid ${ts.border}`, padding: '10px 20px', borderRadius: '12px', cursor: 'pointer', marginBottom: '24px', display:'flex', alignItems:'center', gap:'8px' }} onClick={() => navigate(-1)}>
//         <ChevronLeft size={18}/> Back
//       </button>

//       <div style={styles.card}>
//         <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'20px'}}>
//             <div>
//                 <h1 style={{ margin: 0, fontSize: '30px', fontWeight: 800, background: ts.gradientPrimary, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{restaurantName}</h1>
//                 <p style={{color: ts.textMuted, margin:'5px 0 0 0'}}>Manage dishes and scan new menus</p>
//             </div>
//             <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
//               {/* 🔄 Commission Button */}
//               <button 
//                 onClick={() => { setTempCommission(commission); setShowCommissionModal(true); }} 
//                 style={{ background: ts.surfaceLighter, border: `1px solid ${ts.border}`, color: ts.textPrimary, padding: '10px 20px', borderRadius: '12px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 600 }}
//               >
//                 <Percent size={16} color={ts.primary} />
//                 Commission: {commission}%
//               </button>
//               <button onClick={() => {setPreSelectedImage(null); setShowAIScanModal(true)}} style={{ background: ts.primary, color: 'black', border: 'none', padding: '12px 24px', borderRadius: '12px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
//                   <Sparkles size={16}/> AI Scan Menu
//               </button>
//             </div>
//         </div>
//       </div>

//       {/* VENDOR MENU IMAGES SECTION */}
//       <div style={{marginBottom: '15px', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '8px'}}>
//          <ImageIcon size={18} color={ts.primary}/> Menu Pages & PDFs (Sent by Vendor)
//       </div>
//       <div style={styles.vendorGrid}>
//         {vendorMenus.length > 0 ? vendorMenus.map((menu, i) => (
//           <div key={i} className="vendor-box" style={styles.vendorImgBox} onClick={() => handleScanVendorImage(menu.filename)}>
//               <img src={`${serverURL}/uploads/${menu.filename}`} style={{width:'100%', height:'100%', objectFit:'cover'}} alt="menu-page" onError={(e) => { e.target.src = "https://via.placeholder.com/120x160?text=Menu+Page"; }}/>
//               <div className="scan-overlay" style={{position:'absolute', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', opacity:0, transition:'0.3s'}}>
//                   <Sparkles size={20} color="white"/>
//               </div>
//               <div style={{position:'absolute', bottom:0, width:'100%', padding:'4px', background:'rgba(0,0,0,0.7)', fontSize:'10px', color:'white', textAlign:'center'}}>
//                   Page {i+1}
//               </div>
//           </div>
//         )) : [1,2,3,4,5].map(n => (
//           <div key={n} style={{...styles.vendorImgBox, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', color: ts.textMuted, opacity: 0.5}}>
//               <Plus size={24} />
//               <span style={{fontSize:'10px', marginTop:'5px'}}>Page {n}</span>
//           </div>
//         ))}
//       </div>

//       <input style={{ width: '100%', padding: '14px', borderRadius: '14px', background: ts.surface, border: `1px solid ${ts.border}`, color: ts.textPrimary, marginBottom: '24px' }} placeholder="Search dish by name..." value={search} onChange={(e) => {setSearch(e.target.value); setCurrentPage(1);}} />

//       <div style={{ ...styles.card, padding: 0, overflow: 'hidden' }}>
//         <table style={styles.table}>
//           <thead>
//             <tr>
//               <th style={styles.th}>Dish</th>
//               <th style={styles.th}>Item Details</th>
//               <th style={styles.th}>Menu Price</th>
//               <th style={styles.th}>Customer Price</th>
//               <th style={styles.th}>Vendor Earns</th>
//               <th style={styles.th}>ZaptoDoor Profit</th>
//               <th style={styles.th}>Type</th>
//               <th style={styles.th}>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentItems.map((item, idx) => {
//               let variants = [];
//               try {
//                 variants = Array.isArray(item.variant) ? item.variant : JSON.parse(item.variant || '[]');
//               } catch(e) { variants = []; }

//               if (variants.length === 0) {
//                 const { menu, customer, vendor, profit } = getMenuCustomerVendor(item);
//                 return (
//                   <tr key={idx}>
//                     <td style={styles.td}>
//                       <img src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`} style={styles.img} onError={e => e.target.src="https://via.placeholder.com/50"} />
//                     </td>
//                     <td style={styles.td}>
//                       <div style={{ fontWeight: 700, color: ts.textPrimary, fontSize: '15px' }}>{item.name}</div>
//                       <div style={{ fontSize: '11px', color: ts.textMuted }}>{item.description?.substring(0,40)}...</div>
//                     </td>
//                     <td style={styles.td}>
//                       <span style={{ fontWeight: 600, color: ts.textPrimary }}>₹{menu.toFixed(0)}</span>
//                     </td>
//                     <td style={styles.td}>
//                       <span style={{ color: ts.warning, fontWeight: 700 }}>₹{customer.toFixed(0)}</span>
//                     </td>
//                     <td style={styles.td}>
//                       <span style={{ color: ts.success, fontWeight: 700 }}>₹{vendor.toFixed(0)}</span>
//                     </td>
//                     <td style={styles.td}>
//                       <span style={{ color: ts.primary, fontWeight: 700 }}>+₹{profit.toFixed(0)}</span>
//                     </td>
//                     <td style={styles.td}>
//                       <span style={{ padding: '4px 10px', borderRadius: '8px', background: item.is_veg === 'yes' ? "#065f46" : "#991b1b", color: "white", fontSize: '10px', fontWeight: 700 }}>{item.is_veg === 'yes' ? "VEG" : "NON-VEG"}</span>
//                     </td>
//                     <td style={styles.td}>
//                       <div style={{ display: 'flex', gap: '10px' }}>
//                         <button onClick={() => {setSelectedItem(item); setShowEditModal(true)}} style={{ background: 'none', border: 'none', color: ts.primary, cursor: 'pointer' }}><Sparkles size={14} /></button>
//                         <button onClick={() => handleDelete(item.product_id)} style={{ background: 'none', border: 'none', color: ts.error, cursor: 'pointer' }}><X size={14}/></button>
//                       </div>
//                     </td>
//                   </tr>
//                 );
//               }

//               // With variants
//               return variants.map((v, vIdx) => {
//                 const { menu, customer, vendor, profit } = getVariantPricing(v);
//                 return (
//                   <tr key={`${idx}-${vIdx}`}>
//                     {vIdx === 0 && (
//                       <>
//                         <td style={styles.td} rowSpan={variants.length}>
//                           <img src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`} style={styles.img} onError={e => e.target.src="https://via.placeholder.com/50"} />
//                         </td>
//                         <td style={styles.td} rowSpan={variants.length}>
//                           <div style={{ fontWeight: 700, color: ts.textPrimary, fontSize: '15px' }}>{item.name}</div>
//                           <div style={{ fontSize: '11px', color: ts.textMuted }}>{item.description?.substring(0,40)}...</div>
//                         </td>
//                       </>
//                     )}
//                     <td style={styles.td}>
//                       <span style={{ fontWeight: 600, color: ts.textPrimary }}>{v.unit_value || 'Price'}: ₹{menu.toFixed(0)}</span>
//                     </td>
//                     <td style={styles.td}>
//                       <span style={{ color: ts.warning, fontWeight: 700 }}>{v.unit_value || 'Price'}: ₹{customer.toFixed(0)}</span>
//                     </td>
//                     <td style={styles.td}>
//                       <span style={{ color: ts.success, fontWeight: 700 }}>{v.unit_value || 'Price'}: ₹{vendor.toFixed(0)}</span>
//                     </td>
//                     <td style={styles.td}>
//                       <span style={{ color: ts.primary, fontWeight: 700 }}>+₹{profit.toFixed(0)}</span>
//                     </td>
//                     {vIdx === 0 && (
//                       <>
//                         <td style={styles.td} rowSpan={variants.length}>
//                           <span style={{ padding: '4px 10px', borderRadius: '8px', background: item.is_veg === 'yes' ? "#065f46" : "#991b1b", color: "white", fontSize: '10px', fontWeight: 700 }}>{item.is_veg === 'yes' ? "VEG" : "NON-VEG"}</span>
//                         </td>
//                         <td style={styles.td} rowSpan={variants.length}>
//                           <div style={{ display: 'flex', gap: '10px' }}>
//                             <button onClick={() => {setSelectedItem(item); setShowEditModal(true)}} style={{ background: 'none', border: 'none', color: ts.primary, cursor: 'pointer' }}><Sparkles size={14} /></button>
//                             <button onClick={() => handleDelete(item.product_id)} style={{ background: 'none', border: 'none', color: ts.error, cursor: 'pointer' }}><X size={14}/></button>
//                           </div>
//                         </td>
//                       </>
//                     )}
//                   </tr>
//                 );
//               });
//             })}
//           </tbody>
//         </table>

//         <div style={{ padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: `1px solid ${ts.border}`, background: ts.surfaceLighter }}>
//             <div style={{fontSize:'12px', color: ts.textMuted}}>
//                 Showing {currentItems.length} of {filteredItems.length} items
//             </div>
//             <div style={{ display: 'flex', alignItems: 'center' }}>
//                 <button 
//                   disabled={currentPage === 1} 
//                   onClick={() => setCurrentPage(currentPage - 1)}
//                   style={{...styles.paginationBtn(false), opacity: currentPage === 1 ? 0.5 : 1}}
//                 >
//                     <ChevronLeft size={16}/>
//                 </button>
//                 {[...Array(totalPages)].map((_, i) => (
//                     <button 
//                       key={i} 
//                       onClick={() => setCurrentPage(i + 1)}
//                       style={styles.paginationBtn(currentPage === i + 1)}
//                     >
//                         {i + 1}
//                     </button>
//                 ))}
//                 <button 
//                   disabled={currentPage === totalPages} 
//                   onClick={() => setCurrentPage(currentPage + 1)}
//                   style={{...styles.paginationBtn(false), opacity: currentPage === totalPages ? 0.5 : 1}}
//                 >
//                     <ChevronRight size={16}/>
//                 </button>
//             </div>
//         </div>
//       </div>
      
//       <AIScanModal 
//         isOpen={showAIScanModal} 
//         onClose={() => {setShowAIScanModal(false); setPreSelectedImage(null);}} 
//         designationId={designation_id} 
//         restaurantName={restaurantName} 
//         onItemsAdded={fetchMenu}
//         preSelectedServerImage={preSelectedImage} 
//         // 🔄 Pass commission to modal
//         commission={commission}
//       />
//       {showEditModal && <EditItemModal isOpen={showEditModal} onClose={()=>setShowEditModal(false)} item={selectedItem} designationId={designation_id} onUpdate={fetchMenu} ts={ts} />}

//       {/* 🔄 Commission Modal */}
//       {showCommissionModal && (
//         <div style={styles.modalOverlay} onClick={() => setShowCommissionModal(false)}>
//           <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
//             <h3 style={{ margin: '0 0 15px 0', color: ts.textPrimary }}>Set Commission for {restaurantName}</h3>
//             <input 
//               type="number" 
//               value={tempCommission} 
//               onChange={(e) => setTempCommission(Number(e.target.value))}
//               style={{ width: '100%', padding: '12px', borderRadius: '8px', border: `1px solid ${ts.border}`, background: ts.background, color: ts.textPrimary, fontSize: '16px' }}
//               min="0" max="100"
//             />
//             <div style={{ display: 'flex', gap: '12px', marginTop: '20px', justifyContent: 'flex-end' }}>
//               <button onClick={() => setShowCommissionModal(false)} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: ts.surfaceLighter, color: ts.textSecondary, cursor: 'pointer' }}>Cancel</button>
//               <button onClick={handleUpdateCommission} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: ts.primary, color: '#fff', cursor: 'pointer' }}>Save</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );

// };
// Admin.defaultProps = {
//   isDark: true
// };
// const modalStyles = {
//   overlay: {
//     position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 9999,
//     display: 'flex', alignItems: 'center', justifyContent: 'center'
//   },
//   content: {
//     background: ts.surface, padding: '30px', borderRadius: '20px', maxWidth: '400px', width: '90%',
//     border: `1px solid ${ts.border}`, boxShadow: ts.shadowMd
//   }
// };

// export default Admin;

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { postData, getData, serverURL } from "../../../../Services/Fetchnodeservices";
import { Image as ImageIcon, Plus, Sparkles, X, ChevronLeft, ChevronRight, Percent } from 'lucide-react'; 
import AIScanModal from "./AIScanModal";
import EditItemModal from "./EditItemModal";

const getThemeStyles = (isDark) => {
  const themes = {
    dark: {
      background: "#0a0e1a", surface: "#141b2f", surfaceLighter: "#1e2747",
      border: "#2a3f5f", borderAccent: "#3d5a8c", textPrimary: "#f8fafc",
      textSecondary: "#cbd5e1", textMuted: "#94a3b8", primary: "#60a5fa",
      primaryLight: "#93c5fd", primaryDark: "#1e40af", success: "#34d399",
      successLight: "#6ee7b7", error: "#f87171", warning: "#fbbf24",
      gradientPrimary: "linear-gradient(135deg, #60a5fa 0%, #a78bfa 50%, #f472b6 100%)",
      gradientCard: "linear-gradient(135deg, #1e2747 0%, #141b2f 100%)",
      shadowMd: "0 8px 16px rgba(0,0,0,0.2)",
    },
    light: {
      background: "#f8fafc", surface: "#ffffff", surfaceLighter: "#f1f5f9",
      border: "#e2e8f0", borderAccent: "#cbd5e1", textPrimary: "#0f172a",
      textSecondary: "#334155", textMuted: "#64748b", primary: "#3b82f6",
      primaryLight: "#60a5fa", primaryDark: "#1e40af", success: "#10b981",
      successLight: "#34d399", error: "#ef4444", warning: "#f59e0b",
      gradientPrimary: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 50%, #ec4899 100%)",
      gradientCard: "linear-gradient(135deg, #ffffff 0%, #f8f4ff 100%)",
      shadowMd: "0 8px 16px rgba(0,0,0,0.1)",
    },
  };
  return themes[isDark ? 'dark' : 'light'];
};

const Admin = ({ isDark = true }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const ts = getThemeStyles(isDark);

  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  
  const [showAIScanModal, setShowAIScanModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [vendorMenus, setVendorMenus] = useState([]);
  const [preSelectedImage, setPreSelectedImage] = useState(null);

  // const [commission, setCommission] = useState(20);

  const [markupCommission, setMarkupCommission] = useState(20);
const [profitCommission, setProfitCommission] = useState(20);
  const [showCommissionModal, setShowCommissionModal] = useState(false);
  const [tempCommission, setTempCommission] = useState(20);

  const designation_id = location.state?.designation_id || JSON.parse(sessionStorage.getItem('selectedRestaurant') || '{}').designation_id;
  const restaurantName = location.state?.restaurantName || JSON.parse(sessionStorage.getItem('selectedRestaurant') || '{}').restaurantName;

  const fetchRestaurantDetails = async () => {
    if (!designation_id) return;
    try {
      const response = await getData(`restaurant/Restrunts/${designation_id}`);
      if (response.status && response.data) {
        const markup = parseFloat(response.data.commission_calc) ?? parseFloat(response.data.comission) ?? 20;
  const profit = parseFloat(response.data.comission) ?? 20; // old field is profit commission
  setMarkupCommission(markup);
  setProfitCommission(profit);
      }
    } catch (e) {
      console.error("Failed to fetch restaurant details:", e);
    }
  };

  const fetchMenu = async () => {
    if (!designation_id) return;
    setLoading(true);
    try {
      const response = await postData("restaurant/Menubydesignation_id", { designation_id });
      let itemsArray = [];
      if (Array.isArray(response) && response[0]?.items) {
        itemsArray = typeof response[0].items === 'string' ? JSON.parse(response[0].items) : response[0].items;
      }
      setMenuItems(itemsArray);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const fetchVendorUploadedMenus = async () => {
    try {
      const resp = await getData(`menuScanner/requests-by-restaurant/${designation_id}`);
      if (resp.success) {
        const allFiles = [];
        resp.data.forEach(req => {
          const files = Array.isArray(req.files) ? req.files : JSON.parse(req.files || '[]');
          files.forEach(f => {
            if (f.type === 'image') allFiles.push({ filename: f.name, date: req.created_at });
          });
        });
        setVendorMenus(allFiles);
      }
    } catch (e) { console.error(e); }
  };

  useEffect(() => { 
    fetchRestaurantDetails();
    fetchMenu(); 
    fetchVendorUploadedMenus();
  }, [designation_id]);

  const handleDelete = async (productId) => {
    if (!window.confirm("Bhai, pakka delete karna hai?")) return;
    try {
      const resp = await postData(`menu/delete-item/${designation_id}/${productId}`, {}, "DELETE");
      if (resp.success) fetchMenu();
    } catch (e) { console.error(e); }
  };

  const handleScanVendorImage = (filename) => {
    setPreSelectedImage(filename);
    setShowAIScanModal(true);
  };

 const handleUpdateCommission = async () => {
  try {
    const resp = await postData(`restaurant/updaterestaurant/${designation_id}`, {
      commission_calc: tempCommission
    });
    if (resp.success) {
      setMarkupCommission(tempCommission);   // ✅ yeh sahi hai
      setShowCommissionModal(false);
      fetchMenu();
    } else {
      alert("Failed to update commission");
    }
  } catch (e) {
    console.error(e);
    alert("Error updating commission");
  }
};

  // ===== PRICING HELPERS – FIXED =====
  // Menu price is ALWAYS `base_price` (or `requested_price` as fallback)
  // Never derive menu from customer using current commission
  const getMenuCustomerVendor = (item) => {
  let base = parseFloat(item.base_price) || parseFloat(item.requested_price) || 0;
  if (!base && item.price) base = Math.round(item.price / 1.2); // fallback
  if (!base) return { menu: 0, customer: 0, vendor: 0, profit: 0 };
  const customer = Math.round(base * (1 + markupCommission / 100));
  const profit = Math.round(customer * (profitCommission / 100));
  const vendor = customer - profit;
  return { menu: base, customer, vendor, profit };
};

  // Variants – same logic
  const getVariantPricing = (variant) => {
  let base = parseFloat(variant.base_price) || parseFloat(variant.actual_price) || 0;
  if (!base && variant.item_price_variant) base = Math.round(variant.item_price_variant / 1.2);
  if (!base) return { menu: 0, customer: 0, vendor: 0, profit: 0 };
  const customer = Math.round(base * (1 + markupCommission / 100));
  const profit = Math.round(customer * (profitCommission / 100));
  const vendor = customer - profit;
  return { menu: base, customer, vendor, profit };
};

  const filteredItems = menuItems.filter(item =>
    item.name?.toLowerCase().includes(search.toLowerCase()) ||
    item.category?.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
  const currentItems = filteredItems.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const styles = {
    container: { minHeight: "100vh", background: ts.background, padding: "32px 40px", color: ts.textPrimary, fontFamily: 'Inter, sans-serif' },
    card: { background: ts.surface, border: `1px solid ${ts.border}`, borderRadius: "24px", padding: "32px", marginBottom: "32px", boxShadow: ts.shadowMd, backgroundImage: ts.gradientCard },
    vendorGrid: { display: 'flex', gap: '15px', overflowX: 'auto', paddingBottom: '10px', marginBottom: '32px' },
    vendorImgBox: { minWidth: '120px', height: '160px', borderRadius: '12px', border: `2px dashed ${ts.border}`, background: ts.surfaceLighter, overflow: 'hidden', cursor: 'pointer', position: 'relative' },
    table: { width: "100%", borderCollapse: "collapse" },
    th: { padding: "16px", textAlign: "left", fontSize: "12px", fontWeight: 700, color: ts.primary, background: ts.surfaceLighter, textTransform: "uppercase", borderBottom: `1px solid ${ts.border}` },
    td: { padding: "14px 16px", borderBottom: `1px solid ${ts.border}`, fontSize: "13px", color: ts.textSecondary },
    badge: { display: 'block', fontSize: '10px', background: ts.surfaceLighter, padding: '3px 8px', borderRadius: '5px', marginBottom: '4px', border: `1px solid ${ts.border}` },
    img: { width: "50px", height: "50px", borderRadius: "10px", objectFit: "cover", border: `1px solid ${ts.border}` },
    paginationBtn: (active) => ({ padding: "8px 16px", borderRadius: "10px", border: `1px solid ${active ? ts.primary : ts.border}`, background: active ? ts.primary : ts.surface, color: active ? "white" : ts.textSecondary, cursor: "pointer", margin: "0 4px", fontSize: '12px', fontWeight: 600 }),
    modalOverlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' },
    modalContent: { background: ts.surface, padding: '30px', borderRadius: '20px', maxWidth: '400px', width: '90%', border: `1px solid ${ts.border}`, boxShadow: ts.shadowMd }
  };

  return (
    <div style={styles.container}>
      <style>{`
        tr:hover { background: ${ts.primary}08 !important; } 
        input:focus { border-color: ${ts.primary} !important; outline: none; }
        .vendor-box:hover .scan-overlay { opacity: 1 !important; }
        ::-webkit-scrollbar { height: 6px; }
        ::-webkit-scrollbar-thumb { background: ${ts.border}; borderRadius: 10px; }
      `}</style>
      
      <button style={{ background: ts.surfaceLighter, color: ts.primary, border: `1px solid ${ts.border}`, padding: '10px 20px', borderRadius: '12px', cursor: 'pointer', marginBottom: '24px', display:'flex', alignItems:'center', gap:'8px' }} onClick={() => navigate(-1)}>
        <ChevronLeft size={18}/> Back
      </button>

      <div style={styles.card}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'20px'}}>
            <div>
                <h1 style={{ margin: 0, fontSize: '30px', fontWeight: 800, background: ts.gradientPrimary, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>{restaurantName}</h1>
                <p style={{color: ts.textMuted, margin:'5px 0 0 0'}}>Manage dishes and scan new menus</p>
            </div>
            <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
              <button 
  onClick={() => { setTempCommission(markupCommission); setShowCommissionModal(true); }} 
                style={{ background: ts.surfaceLighter, border: `1px solid ${ts.border}`, color: ts.textPrimary, padding: '10px 20px', borderRadius: '12px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 600 }}
              >
                 <Percent size={16} color={ts.primary} />
  Markup: {markupCommission}% | Profit: {profitCommission}%
              </button>
              <button onClick={() => {setPreSelectedImage(null); setShowAIScanModal(true)}} style={{ background: ts.primary, color: 'black', border: 'none', padding: '12px 24px', borderRadius: '12px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Sparkles size={16}/> AI Scan Menu
              </button>
            </div>
        </div>
      </div>

      <div style={{marginBottom: '15px', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '8px'}}>
         <ImageIcon size={18} color={ts.primary}/> Menu Pages & PDFs (Sent by Vendor)
      </div>
      <div style={styles.vendorGrid}>
        {vendorMenus.length > 0 ? vendorMenus.map((menu, i) => (
          <div key={i} className="vendor-box" style={styles.vendorImgBox} onClick={() => handleScanVendorImage(menu.filename)}>
              <img src={`${serverURL}/uploads/${menu.filename}`} style={{width:'100%', height:'100%', objectFit:'cover'}} alt="menu-page" onError={(e) => { e.target.src = "https://via.placeholder.com/120x160?text=Menu+Page"; }}/>
              <div className="scan-overlay" style={{position:'absolute', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', opacity:0, transition:'0.3s'}}>
                  <Sparkles size={20} color="white"/>
              </div>
              <div style={{position:'absolute', bottom:0, width:'100%', padding:'4px', background:'rgba(0,0,0,0.7)', fontSize:'10px', color:'white', textAlign:'center'}}>
                  Page {i+1}
              </div>
          </div>
        )) : [1,2,3,4,5].map(n => (
          <div key={n} style={{...styles.vendorImgBox, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', color: ts.textMuted, opacity: 0.5}}>
              <Plus size={24} />
              <span style={{fontSize:'10px', marginTop:'5px'}}>Page {n}</span>
          </div>
        ))}
      </div>

      <input style={{ width: '100%', padding: '14px', borderRadius: '14px', background: ts.surface, border: `1px solid ${ts.border}`, color: ts.textPrimary, marginBottom: '24px' }} placeholder="Search dish by name..." value={search} onChange={(e) => {setSearch(e.target.value); setCurrentPage(1);}} />

      <div style={{ ...styles.card, padding: 0, overflow: 'hidden' }}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Dish</th>
              <th style={styles.th}>Item Details</th>
              <th style={styles.th}>Menu Price</th>
              <th style={styles.th}>Customer Price</th>
              <th style={styles.th}>Vendor Earns</th>
              <th style={styles.th}>ZaptoDoor Profit</th>
              <th style={styles.th}>Type</th>
              <th style={styles.th}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item, idx) => {
              let variants = [];
              try {
                variants = Array.isArray(item.variant) ? item.variant : JSON.parse(item.variant || '[]');
              } catch(e) { variants = []; }

              if (variants.length === 0) {
                const { menu, customer, vendor, profit } = getMenuCustomerVendor(item);
                return (
                  <tr key={idx}>
                    <td style={styles.td}>
                      <img src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`} style={styles.img} onError={e => e.target.src="https://via.placeholder.com/50"} />
                    </td>
                    <td style={styles.td}>
                      <div style={{ fontWeight: 700, color: ts.textPrimary, fontSize: '15px' }}>{item.name}</div>
                      <div style={{ fontSize: '11px', color: ts.textMuted }}>{item.description?.substring(0,40)}...</div>
                    </td>
                    <td style={styles.td}>
                      <span style={{ fontWeight: 600, color: ts.textPrimary }}>₹{menu.toFixed(0)}</span>
                    </td>
                    <td style={styles.td}>
                      <span style={{ color: ts.warning, fontWeight: 700 }}>₹{customer.toFixed(0)}</span>
                    </td>
                    <td style={styles.td}>
                      <span style={{ color: ts.success, fontWeight: 700 }}>₹{vendor.toFixed(0)}</span>
                    </td>
                    <td style={styles.td}>
                      <span style={{ color: ts.primary, fontWeight: 700 }}>+₹{profit.toFixed(0)}</span>
                    </td>
                    <td style={styles.td}>
                      <span style={{ padding: '4px 10px', borderRadius: '8px', background: item.is_veg === 'yes' ? "#065f46" : "#991b1b", color: "white", fontSize: '10px', fontWeight: 700 }}>{item.is_veg === 'yes' ? "VEG" : "NON-VEG"}</span>
                    </td>
                    <td style={styles.td}>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <button onClick={() => {setSelectedItem(item); setShowEditModal(true)}} style={{ background: 'none', border: 'none', color: ts.primary, cursor: 'pointer' }}><Sparkles size={14} /></button>
                        <button onClick={() => handleDelete(item.product_id)} style={{ background: 'none', border: 'none', color: ts.error, cursor: 'pointer' }}><X size={14}/></button>
                      </div>
                    </td>
                  </tr>
                );
              }

              return variants.map((v, vIdx) => {
                const { menu, customer, vendor, profit } = getVariantPricing(v);
                return (
                  <tr key={`${idx}-${vIdx}`}>
                    {vIdx === 0 && (
                      <>
                        <td style={styles.td} rowSpan={variants.length}>
                          <img src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`} style={styles.img} onError={e => e.target.src="https://via.placeholder.com/50"} />
                        </td>
                        <td style={styles.td} rowSpan={variants.length}>
                          <div style={{ fontWeight: 700, color: ts.textPrimary, fontSize: '15px' }}>{item.name}</div>
                          <div style={{ fontSize: '11px', color: ts.textMuted }}>{item.description?.substring(0,40)}...</div>
                        </td>
                      </>
                    )}
                    <td style={styles.td}>
                      <span style={{ fontWeight: 600, color: ts.textPrimary }}>{v.unit_value || 'Price'}: ₹{menu.toFixed(0)}</span>
                    </td>
                    <td style={styles.td}>
                      <span style={{ color: ts.warning, fontWeight: 700 }}>{v.unit_value || 'Price'}: ₹{customer.toFixed(0)}</span>
                    </td>
                    <td style={styles.td}>
                      <span style={{ color: ts.success, fontWeight: 700 }}>{v.unit_value || 'Price'}: ₹{vendor.toFixed(0)}</span>
                    </td>
                    <td style={styles.td}>
                      <span style={{ color: ts.primary, fontWeight: 700 }}>+₹{profit.toFixed(0)}</span>
                    </td>
                    {vIdx === 0 && (
                      <>
                        <td style={styles.td} rowSpan={variants.length}>
                          <span style={{ padding: '4px 10px', borderRadius: '8px', background: item.is_veg === 'yes' ? "#065f46" : "#991b1b", color: "white", fontSize: '10px', fontWeight: 700 }}>{item.is_veg === 'yes' ? "VEG" : "NON-VEG"}</span>
                        </td>
                        <td style={styles.td} rowSpan={variants.length}>
                          <div style={{ display: 'flex', gap: '10px' }}>
                            <button onClick={() => {setSelectedItem(item); setShowEditModal(true)}} style={{ background: 'none', border: 'none', color: ts.primary, cursor: 'pointer' }}><Sparkles size={14} /></button>
                            <button onClick={() => handleDelete(item.product_id)} style={{ background: 'none', border: 'none', color: ts.error, cursor: 'pointer' }}><X size={14}/></button>
                          </div>
                        </td>
                      </>
                    )}
                  </tr>
                );
              });
            })}
          </tbody>
        </table>

        <div style={{ padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: `1px solid ${ts.border}`, background: ts.surfaceLighter }}>
            <div style={{fontSize:'12px', color: ts.textMuted}}>
                Showing {currentItems.length} of {filteredItems.length} items
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <button 
                  disabled={currentPage === 1} 
                  onClick={() => setCurrentPage(currentPage - 1)}
                  style={{...styles.paginationBtn(false), opacity: currentPage === 1 ? 0.5 : 1}}
                >
                    <ChevronLeft size={16}/>
                </button>
                {[...Array(totalPages)].map((_, i) => (
                    <button 
                      key={i} 
                      onClick={() => setCurrentPage(i + 1)}
                      style={styles.paginationBtn(currentPage === i + 1)}
                    >
                        {i + 1}
                    </button>
                ))}
                <button 
                  disabled={currentPage === totalPages} 
                  onClick={() => setCurrentPage(currentPage + 1)}
                  style={{...styles.paginationBtn(false), opacity: currentPage === totalPages ? 0.5 : 1}}
                >
                    <ChevronRight size={16}/>
                </button>
            </div>
        </div>
      </div>
      
      <AIScanModal 
        isOpen={showAIScanModal} 
        onClose={() => {setShowAIScanModal(false); setPreSelectedImage(null);}} 
        designationId={designation_id} 
        restaurantName={restaurantName} 
        onItemsAdded={fetchMenu}
        preSelectedServerImage={preSelectedImage} 
        // commission={commission}
        markupCommission={markupCommission} 
  profitCommission={profitCommission} 
      />
      {showEditModal && <EditItemModal isOpen={showEditModal} onClose={()=>setShowEditModal(false)} item={selectedItem} designationId={designation_id} onUpdate={fetchMenu} ts={ts} />}

      {showCommissionModal && (
        <div style={styles.modalOverlay} onClick={() => setShowCommissionModal(false)}>
          <div style={styles.modalContent} onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 15px 0', color: ts.textPrimary }}>Set Commission for {restaurantName}</h3>
            <input 
              type="number" 
              value={tempCommission} 
              onChange={(e) => setTempCommission(Number(e.target.value))}
              style={{ width: '100%', padding: '12px', borderRadius: '8px', border: `1px solid ${ts.border}`, background: ts.background, color: ts.textPrimary, fontSize: '16px' }}
              min="0" max="100"
            />
            <div style={{ display: 'flex', gap: '12px', marginTop: '20px', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowCommissionModal(false)} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: ts.surfaceLighter, color: ts.textSecondary, cursor: 'pointer' }}>Cancel</button>
              <button onClick={handleUpdateCommission} style={{ padding: '10px 20px', borderRadius: '8px', border: 'none', background: ts.primary, color: '#fff', cursor: 'pointer' }}>Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

Admin.defaultProps = {
  isDark: true
};

export default Admin;